import React from 'react'

export default class Carousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = { index: 0, images: [] };
  }

  clickPrev () {
    var newindex = this.state.index - 1;
    if (newindex < 0) newindex = this.props.images.length - 1;
    this.setState({
      index: newindex,
      image: this.props.images[newindex].url,
      caption: this.props.images[newindex].caption,
    });
  }

  clickNext () {
    var newindex = this.state.index + 1;
    if (newindex >= this.props.images.length) newindex = 0;
    this.setState({
      index: newindex,
      image: this.props.images[newindex].url,
      caption: this.props.images[newindex].caption,
    });
  }

  componentWillMount() {
    // update first image state
    this.setState({
      image: this.props.images[this.state.index].url,
      caption: this.props.images[this.state.index].caption,
    });
  }

  render () {
    var img = <img src={'/' + this.state.image} />
    return (
      <div className="imagecarousel">
        <div className="inner">
          <div className="prevButton" onClick={this.clickPrev.bind(this)}><span><img src="/img/prev.png" alt="Previous" /></span></div>
          <div className="nextButton" onClick={this.clickNext.bind(this)}><span><img src="/img/next.png" alt="Next" /></span></div>
          <div className="image" onClick={this.clickNext.bind(this)}>{img}</div>
          { this.state.caption ? <div className="caption">{this.state.caption}</div> : <div className="caption empty"></div> }
        </div>
      </div>
    )
  }
}

